module.exports = __webpack_public_path__ + "static/media/icon_mission_mbox_upload.92ba111c.svg";